import styled from 'styled-components';

export const StyledFixedWidthPageContainer = styled.div`
    padding: 0 16px;
    width: 1300px;
    max-width: 100%;
    margin: 0 auto;
`;
